export const getSupplierListQuery = `
  query ListAllSuppliers($storeId: String) {
    listAllSuppliers(storeId: $storeId) {
      code
      suppliers {
        id
        storeId
        name
        email
        phone
        status
        address {
          country
          province
          district
          sector
          cell
          village
          streetAddress
        }
      }
    }
  }
`;

export const createSupplierQuery = `
 mutation CreateSupplier($input: CreateSupplierInput!) {
    createSupplier(input: $input) {
        code
        supplier {
            id
            storeId
            name
            email
            phone
            status
            address {
                country
                province
                district
                sector
                cell
                village
                streetAddress
            }
        }
    }
 }
`;

export const updateSupplierQuery = `
 mutation UpdateSupplier($input: UpdateSupplierInput!) {
    updateSupplier(input: $input) {
        code
        supplier {
            id
            storeId
            name
            email
            phone
            status
            address {
                country
                province
                district
                sector
                cell
                village
                streetAddress
            }
        }
    }
 }
`;

export const addStoreSupplierQuery = `
 mutation AddStoreSupplier($input: AddStoreSupplierInput!) {
    addStoreSupplier(input: $input) {
        id
        companyId
        name
        status
        supplierIds
        address {
            country
            province
            district
            sector
            cell
            village
            streetAddress
        }
    }
 }
`;

export const removeStoreSupplierQuery = `
 mutation RemoveStoreSupplier($input: RemoveStoreSupplierInput!) {
    removeStoreSupplier(input: $input) {
        id
        companyId
        name
        status
        supplierIds
        address {
            country
            province
            district
            sector
            cell
            village
            streetAddress
        }
    }
 }
`;

export const searchSuppliersQuery = `
 query SearchSuppliers($input: SearchSuppliersInput!) {
    searchSuppliers(input: $input) {
        suppliers {
            id
            storeId
            name
            email
            phone
            status
            address {
                country
                province
                district
                sector
                cell
                village
                streetAddress
            }
        }
    }
 }
`;

export const deleteSupplierQuery = `
 mutation DeleteSupplier($input: DeleteSupplierInput!) {
    deleteSupplier(input: $input) {
        code
    }
 }
`;
